import request from '@/utils/request'

// 获取相册列表
export function GalleryGetList(data){
    return request({
        method:'get',
        url:'Album/getList',
        params:data
    })
}
// 相册详情
export function albumDetails(data){
    return request({
        method:'get',
        url:'Album/albumDetails',
        params:data
    })
}



// WEBPACK FOOTER //
// ./src/api/Album.js